import Form from "react-bootstrap/Form";
import ValidationMessage from "../validation-message/validation-message";

const TextArea = ({
  label,
  name,
  placeholder,
  register,
  rows = "4",
  errors = null,
  noSpacing = false,
  disabled = false
}) => {
  return (
    <Form.Group controlId={label} className={!noSpacing ? "mb-3" : ""}>
      {label ? (
        <Form.Label className={errors ? "text-danger" : ""}>
          {label} {errors && "*"}
        </Form.Label>
      ) : (
        ""
      )}
      <Form.Control
        rows={rows}
        as="textarea"
        {...register(name)}
        placeholder={placeholder}
        className={errors ? "border-danger" : ""}
        disabled={disabled}
      />
      {errors && <ValidationMessage error={errors?.message} />}
    </Form.Group>
  );
};
export default TextArea;
